export default "__VITE_PUBLIC_ASSET__fc291acf__"